import React from 'react';
import { Box, Text } from '@wix/design-system';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import { useHeroInsightBullets } from './useHeroInsightBullets';
const TOTAL_ROWS = 2;
export const HeroInsightBullets = _ref => {
  let {
    domain,
    LeadingBullet
  } = _ref;
  const bullets = useHeroInsightBullets(domain, {
    totalRows: TOTAL_ROWS - (LeadingBullet ? 1 : 0)
  });
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "9px",
    width: "100%"
  }, LeadingBullet && /*#__PURE__*/React.createElement(LeadingBullet, null), bullets.map(bullet => /*#__PURE__*/React.createElement(Box, {
    key: bullet,
    direction: "horizontal",
    gap: "10px",
    align: "left"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "top",
    marginTop: "3px"
  }, /*#__PURE__*/React.createElement(SparklesFilledSmall, null))), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    secondary: true
  }, bullet))));
};
//# sourceMappingURL=HeroInsightBullets.js.map